import { handleApiError } from './apiError'
import { CustomComponentLibraryApi, DefaultConfig, InitOverrideFunction, RequestOpts } from './retool_client'
import undici, { Agent } from 'undici'

export class CustomComponentLibraryWrappedClient extends CustomComponentLibraryApi {
  constructor(configuration = DefaultConfig, protected unixProxy: undefined | string = undefined, protected verbose: boolean = false) {
    super(configuration)
    this.unixProxy = unixProxy
    this.verbose = verbose
  }

  protected override async request(
    context: RequestOpts,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Response> {
    if (this.unixProxy) {
      if (initOverrides) {
        if (typeof initOverrides !== 'function') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          initOverrides['dispatcher'] = new undici.Agent({ socketPath: this.unixProxy } as Agent.Options)
        }
      } else {
        initOverrides = {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          dispatcher: new undici.Agent({ socketPath: this.unixProxy } as any),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
    }

  try {
    const result = await super.request(context, initOverrides)
    return result
  } catch (e) {
    const error = handleApiError(this.configuration.basePath, e, this.verbose)
    throw error
  }
}
}
